import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
import { AxiosError } from "axios";

const getLocationData = async (
  lat: number,
  long: number,
  locationId?: string
) => {
  const params = new URLSearchParams({
    lat: lat.toString(),
    long: long.toString(),
  });
  if (!locationId) return new AxiosError("Location id not provided");
  params.append("locationId", locationId);
  return await axiosInstance
    .get(`buildings/location`, { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetLocationData = (lat: number, long: number, locationId?: string) => {
  return useQuery({
    queryKey: ["locationData", locationId, lat, long],
    queryFn: () => getLocationData(lat, long, locationId),
    enabled: !!locationId,
  });
};

export default useGetLocationData;
